import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { client } from '../../client';
import UploadImage from '../../API/UploadImage';
import EditUserInfo from './EditUserInfo';
import { firestore } from '../../firebase';
import { addDoc, collection } from '@firebase/firestore';

const activeBtnStyles = 'bg-indigo-500 text-white text-xs font-bold p-2 rounded-full w-auto m-1 outline-none';
const notActiveBtnStyles = 'bg-primary text-black text-xs font-bold p-2 rounded-full w-auto m-1 outline-none';

const UserSettings = ({ user }) => {
    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState();
    const [birthday, setBirthday] = useState();
    const [address, setAddress] = useState();
    const [imageAsset, setImageAsset] = useState();
    const [activeBtn, setActiveBtn] = useState('info');
    const ref = collection(firestore, "messages");

    const navigate = useNavigate();

    useEffect(() => {
        setEmail(user.email);
        setAddress(user.address);
        setPhoneNumber(user?.phoneNumber);
        setBirthday(user.birthday);

    }, [user])


    const savePin = () => {
        console.log("Save pin");

        let data = {
            message: address,
        }

        try {
            addDoc(ref, data);
        } catch (e) {
            console.log(e);
        }

        // if (imageAsset && activeBtn === 'banner') {
        //     client
        //         .patch(user?._id)
        //         .set({
        //             bannerImage: {
        //                 _type: 'image',
        //                 asset: {
        //                     _type: 'reference',
        //                     _ref: imageAsset?._id,
        //                 },
        //             }
        //         })
        //         .commit() // Perform the patch and return a promise
        //         .then((doc) => {
        //             console.log('Hurray, Profile is updated! New document:');
        //             console.log(doc);
        //             navigate('/');
        //         })
        //         .catch((err) => {
        //             console.error('Oh no, the update failed: ', err.message);
        //         })
        // } else if (imageAsset && activeBtn === 'profile') {
        //     client
        //         .patch(user?._id)
        //         .set({
        //             profImage: {
        //                 _type: 'image',
        //                 asset: {
        //                     _type: 'reference',
        //                     _ref: imageAsset?._id,
        //                 },
        //             }
        //         })
        //         .commit() // Perform the patch and return a promise
        //         .then((doc) => {
        //             console.log('Hurray, Profile is updated! New document:');
        //             console.log(doc);
        //             navigate('/');

        //         })
        //         .catch((err) => {
        //             console.error('Oh no, the update failed: ', err.message);
        //         })
        // } else if (activeBtn === 'info') {
        //     console.log("save user info");
        //     console.log(email);
        //     console.log(address);
        //     console.log(phoneNumber);
        //     console.log(birthday);
        //     client
        //         .patch(user?._id)
        //         .set({
        //             email: email,
        //             phoneNumber: phoneNumber,
        //             address: address,
        //             birthDay: birthday,
        //         })
        //         .commit() // Perform the patch and return a promise
        //         .then((doc) => {
        //             console.log('User Info updated');
        //             console.log(doc);
        //             navigate('/');

        //         })
        //         .catch((err) => {
        //             console.error('Oh no, the update failed: ', err.message);
        //         })
        // }
    };


    return (
        <div className="flex flex-col justify-center items-center lg:h-4/5">
            <div className='flex flex-row'>
                {/* <button
                    type="button"
                    onClick={(e) => {
                        // setText(profile);
                        setActiveBtn('profile');
                    }}
                    className={`${activeBtn === 'profile' ? activeBtnStyles : notActiveBtnStyles}`}

                >
                    Profile
                </button> */}
                {/* <button
                    type="button"
                    onClick={(e) => {
                        // setText(profile);
                        setActiveBtn('banner');
                    }}
                    className={`${activeBtn === 'banner' ? activeBtnStyles : notActiveBtnStyles}`}
                >
                    Banner
                </button> */}
                <button
                    type="button"
                    onClick={(e) => {
                        // setText(profile);
                        setActiveBtn('info');
                    }}
                    className={`${activeBtn === 'info' ? activeBtnStyles : notActiveBtnStyles}`}
                >
                    User Info
                </button>
            </div>
            <div className=" flex lg:flex-row flex-col justify-center items-center bg-white lg:p-5 p-3 lg:w-4/5  w-full">
                {activeBtn === 'profile' &&
                    <>
                        <h1>Change Profile Image</h1>
                        <UploadImage imageAsset={imageAsset} setImageAsset={setImageAsset} />
                    </>
                }
                {activeBtn === 'banner' &&
                    <>
                        <h1>Change Banner Image</h1>
                        <UploadImage imageAsset={imageAsset} setImageAsset={setImageAsset} />
                    </>
                }
                {activeBtn === 'info' &&
                    <EditUserInfo
                        email={email} setEmail={setEmail}
                        address={address} setAddress={setAddress}
                        phoneNumber={phoneNumber} setPhoneNumber={setPhoneNumber}
                        birthday={birthday} setBirthday={setBirthday}
                    />
                }
                <div className="flex flex-1 flex-col gap-6 lg:pl-5 mt-5 w-full">
                    <div className="flex flex-col">
                        <div className="flex justify-end items-end mt-5">
                            <button
                                type="button"
                                onClick={savePin}
                                className="bg-indigo-500 text-black font-bold border-2 rounded-full w-28 outline-none"
                            >
                                Update
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UserSettings